var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page", attrs: { type: "card" } },
    [
      _c("template", { slot: "header" }, [_vm._v("主题")]),
      _c(
        "el-table",
        _vm._b({ attrs: { data: _vm.list } }, "el-table", _vm.table, false),
        [
          _c("el-table-column", {
            attrs: { prop: "name", align: "center", width: "260" }
          }),
          _c("el-table-column", {
            attrs: { label: "预览", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _c("div", {
                    staticClass: "theme-preview",
                    style: {
                      backgroundImage:
                        "url(" + _vm.$baseUrl + scope.row.preview + ")"
                    }
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "address", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.activeName === scope.row.name
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "success",
                              icon: "el-icon-check",
                              round: ""
                            }
                          },
                          [_vm._v("已激活")]
                        )
                      : _c(
                          "el-button",
                          {
                            attrs: { round: "" },
                            on: {
                              click: function($event) {
                                return _vm.handleSelectTheme(scope.row.name)
                              }
                            }
                          },
                          [_vm._v("使用")]
                        )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "p",
            [
              _vm._v("尝试激活一个不存在的主题（主题不存在 "),
              _c("d2-icon", { attrs: { name: "arrow-right" } }),
              _vm._v(" 默认主题）")
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { type: "danger" },
              on: {
                click: function($event) {
                  return _vm.handleSelectTheme("err-theme")
                }
              }
            },
            [
              _c("d2-icon", {
                staticClass: "d2-mr-10",
                attrs: { name: "hand-o-right" }
              }),
              _vm._v(" 尝试激活主题 'err-theme' ")
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-button",
        {
          attrs: { slot: "footer", type: "primary", size: "small" },
          slot: "footer"
        },
        [_vm._v(" 当前激活主题 " + _vm._s(_vm.activeName) + " ")]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }